import calcDays from './calcDays'
import cardFlag from './cardFlag'
import cep from './cep'
import cnpj from './cnpj'
import convertBinaryToBool from './convertBinaryToBool'
import convertBoolToBinary from './convertBoolToBinary'
import convertBoolToString from './convertBoolToString'
import cpf from './cpf'
import creditCardNumber from './creditCardNumber'
import currencyInput from './currencyInput'
import date from './date'
import dateFromNow from './dateFromNow'
import dateLocaleFormat from './dateLocaleFormat'
import dates from './dates'
import definedErrorMessage from './definedErrorMessage'
import demoEndDateFormatter from './demoEndDateFormatter'
import document from './document'
import dynamicImageSize from './dynamicImageSize'
import errorMessage from './errorMessage'
import expirationDateCard from './expirationDateCard'
import file from './file'
import float from './float'
import formatDataTomticketRequestPartner from './formatDataTomticketRequestPartner'
import formattedConstantName from './formattedConstantName'
import formatToCurrencyBrl from './formatToCurrencyBrl'
import getMethodIdByBrand from './getMethodIdByBrand'
import hours from './hours'
import htmlToPlainText from './htmlToPlainText'
import money from './money'
import numberToPrice from './numberToPrice'
import onlyNumbers from './onlyNumbers'
import options from './options'
import phone from './phone'
import plansToSupplierForm from './plansToSupplierForm'
import ptBrFormatDateTime from './ptBrFormatDateTime'
import storageTime from './storageTime'
import stylesForSocialMedia from './stylesForSocialMedia'
import tickets from './tickets'
import toISOStringVerify from './toISOStringVerify'
import url from './url'
import vimeoEmbedUrl from './vimeoEmbedUrl'
import website from './website'
import getBrandByMethodId from './getBrandByMethodId'

const formatters = {
  calcDays,
  cardFlag,
  cep,
  cnpj,
  convertBinaryToBool,
  convertBoolToBinary,
  convertBoolToString,
  cpf,
  creditCardNumber,
  currencyInput,
  date,
  dateFromNow,
  dateLocaleFormat,
  dates,
  definedErrorMessage,
  demoEndDateFormatter,
  document,
  dynamicImageSize,
  errorMessage,
  expirationDateCard,
  file,
  float,
  formatDataTomticketRequestPartner,
  formattedConstantName,
  formatToCurrencyBrl,
  getMethodIdByBrand,
  hours,
  htmlToPlainText,
  money,
  numberToPrice,
  onlyNumbers,
  options,
  phone,
  plansToSupplierForm,
  ptBrFormatDateTime,
  storageTime,
  stylesForSocialMedia,
  tickets,
  toISOStringVerify,
  url,
  vimeoEmbedUrl,
  website,
  getBrandByMethodId,
}

export default formatters
